import { NoPrint } from 'src/componentes/print';
import LucideIcon from 'src/componentes/lucide-icon';

function HintTour({ intl, setShowHintTour, ehAgenda = false, ehDash = false, ehAcao = false }) {
  return (
    <NoPrint>
      <div
        className={ehDash ? 'ballonDash' : ehAgenda ? 'ballonAgenda' : ehAcao ? 'ballonAcao' : 'ballon'}
      >
        <span>
          {intl.formatMessage({ id: 'textHintTour' })}{' '}
          <strong>"{intl.formatMessage({ id: 'conhecerPlataforma' })}"</strong>
        </span>
        <a onClick={() => setShowHintTour(false)}>
          <LucideIcon
            icon="close"
            size={18}
            color="white"
            style={{
              display: 'flex',
              position: 'absolute',
              top: '5px',
              right: '7px',
              gap: '10px',
              zIndex: 1000,
            }}
          />
        </a>
      </div>
    </NoPrint>
  );
}

export default HintTour;
